import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Form,
  Modal,
  ToggleButtonGroup,
  ToggleButton,
  Card,
  Row,
  Col,
  // Stack,
  Badge,
} from "react-bootstrap";
import {
  AiOutlineAlignLeft,
  AiOutlineCheckCircle,
  AiOutlinePlus,
  AiOutlineEye,
  AiOutlineUpload,
  AiOutlineArrowLeft,
  AiOutlineEdit,
} from "react-icons/ai";
import { BsStars } from "react-icons/bs";
import { ApiConfig } from "config/ApiConfig";
import axios from "axios";
import { getApiConfig } from "helpers/utils";
import Loader from "components/Loader/Loader";
import "../Modules.css";
import angry from "../../../assets/img/survey-icons/angry-face.svg";
import angryBlack from "../../../assets/img/survey-icons/angry-face-black.svg";
import frown from "../../../assets/img/survey-icons/frown.svg";
import frownBlack from "../../../assets/img/survey-icons/frown-black.svg";
import happyHeart from "../../../assets/img/survey-icons/happy-heart.svg";
import happyHeartBlack from "../../../assets/img/survey-icons/happy-heart-black.svg";
import meh from "../../../assets/img/survey-icons/meh.svg";
import mehBlack from "../../../assets/img/survey-icons/meh-black.svg";
import smile from "../../../assets/img/survey-icons/smile.svg";
import smileBlack from "../../../assets/img/survey-icons/smile-black.svg";
import star from "../../../assets/img/survey-icons/star.svg";
import starBlack from "../../../assets/img/survey-icons/star-black.svg";
import thumbDown from "../../../assets/img/survey-icons/thumb-down.svg";
import thumbDownBlack from "../../../assets/img/survey-icons/thumb-down-black.svg";
import thumbUpBlack from "../../../assets/img/survey-icons/thumbs-up-black.svg";
import thumbUp from "../../../assets/img/survey-icons/thumbs-up.svg";

const smileys = [angry, frown, meh, smile, happyHeart];
const smileysBlack = [
  angryBlack,
  frownBlack,
  mehBlack,
  smileBlack,
  happyHeartBlack,
];

const colors = {
  primary: "#6366f1",
  secondary: "#8b5cf6",
  success: "#10b981",
  danger: "#ef4444",
  light: "#f8fafc",
  dark: "#1e293b",
  muted: "#64748b",
};

const responseFormats = [
  {
    title: "Text Response",
    value: "text",
    icon: <AiOutlineAlignLeft size={24} />,
    description: "Open-ended text answers",
  },
  {
    title: "Numeric Scale",
    value: "numeric",
    icon: <BsStars size={24} />,
    description: "1-5 or 1-10 rating scale",
  },
  {
    title: "Graphic Scale",
    value: "graphic",
    icon: (
      <div style={{ display: "flex", gap: "8px" }}>
        <img src={star} width={20} height={20} alt="star" />
        <img src={happyHeart} width={20} height={20} alt="happy" />
        <img src={thumbUp} width={20} height={20} alt="thumbs up" />
      </div>
    ),
    description: "Visual rating options",
  },
];

const SurveyBuilder = ({ setShowSurvey }) => {
  const [template, setTemplate] = useState("");
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [selectedGraphic, setSelectedGraphic] = useState(null);
  const [step, setStep] = useState(1);
  const [ratingType, setRatingType] = useState(null);
  // const [welcomeMessage, setWelcomeMessage] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [existingTemplates, setExistingTemplates] = useState({});
  const [isLoadingModules, setIsLoadingModules] = useState(false);
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [selectedScoreQuestion, setSelectedScoreQuestion] = useState(null);
  const [templateDescription, setTemplateDescription] = useState("");
  const [answers, setAnswers] = useState({});
  // const [showBenchmarkModal, setShowBenchmarkModal] = useState(false);
  const [benchmark, setBenchmark] = useState({
    min: ratingType === 5 ? 2 : 4,
    max: ratingType === 5 ? 4 : 7,
  });
  const [publishStep, setPublishStep] = useState(1);
  const [editingTemplate, setEditingTemplate] = useState(false);
  const [editingQuestionIndex, setEditingQuestionIndex] = useState(null);

  const handleAnswerChange = (questionKey, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionKey]: prev[questionKey] === value ? 0 : value,
    }));
  };

  const graphicOptions = [
    {
      label: ratingType === 5 ? "5 Stars" : "10 Stars",
      value: "stars",
      icon: [...Array(ratingType === 5 ? 5 : 10)].map((_, i) => (
        <img key={i} src={star} width={20} height={20} alt="star" />
      )),
      preview: (selected) => (
        <div className="d-flex gap-2">
          {[...Array(ratingType === 5 ? 5 : 10)].map((_, i) => (
            <img
              key={i}
              src={selected ? starBlack : star}
              width={20}
              height={20}
              alt="star"
            />
          ))}
        </div>
      ),
    },
    {
      label: "Thumbs Rating",
      value: "thumbs",
      icon: (
        <div className="d-flex gap-3">
          <img src={thumbUp} width={24} height={24} alt="thumbs up" />
          <img src={thumbDown} width={24} height={24} alt="thumbs down" />
        </div>
      ),
      preview: (selected) => (
        <div className="d-flex gap-3">
          <img
            src={selected === "up" ? thumbUpBlack : thumbUp}
            width={24}
            height={24}
            alt="thumbs up"
          />
          <img
            src={selected === "down" ? thumbDownBlack : thumbDown}
            width={24}
            height={24}
            alt="thumbs down"
          />
        </div>
      ),
    },
    ...(ratingType === 5
      ? [
          {
            label: "Smiley Scale",
            value: "smileys",
            icon: (
              <div className="d-flex gap-2">
                <img src={angry} width={20} height={20} alt="angry" />
                <img src={frown} width={20} height={20} alt="frown" />
                <img src={meh} width={20} height={20} alt="neutral" />
                <img src={smile} width={20} height={20} alt="smile" />
                <img src={happyHeart} width={20} height={20} alt="happy" />
              </div>
            ),
            preview: (selected) => {
              return (
                <div className="d-flex gap-2">
                  {smileys.map((icon, i) => (
                    <img
                      key={i}
                      src={selected === i ? smileysBlack[i] : icon}
                      width={24}
                      height={24}
                      alt={`smiley-${i}`}
                    />
                  ))}
                </div>
              );
            },
          },
        ]
      : []),
  ];

  useEffect(() => {
    const fetchFeatureData = async () => {
      try {
        setIsLoadingModules(true);
        const response = await axios.get(ApiConfig.xSurveyDetails, getApiConfig());
        setExistingTemplates(response?.data?.settings || {});
      } catch (error) {
        console.error("Error fetching templates:", error);
      } finally {
        setIsLoadingModules(false);
      }
    };
    fetchFeatureData();
  }, []);

  useEffect(() => {
    setBenchmark({
      min: ratingType === 5 ? 2 : 4,
      max: ratingType === 5 ? 4 : 7,
    });
  }, [ratingType]);

  const handleNext = () => {
    if (step === 1 && template.trim() !== "" && ratingType) {
      setStep(2);
    } else if (step === 2 && currentQuestion.trim() !== "" && selectedFormat) {
      if (selectedFormat === "graphic") {
        setStep(3);
      } else {
        saveQuestion();
        setStep(4);
      }
    } else if (step === 3 && selectedGraphic) {
      saveQuestion();
      setStep(4);
    }
  };

  const handlePrevious = () => {
    if (step > 1) setStep(step - 1);
  };

  const saveQuestion = () => {
    if (editingQuestionIndex !== null) {
      // Update existing question
      const updatedQuestions = [...questions];
      updatedQuestions[editingQuestionIndex] = {
        text: currentQuestion,
        format: selectedFormat,
        graphic: selectedGraphic,
      };
      setQuestions(updatedQuestions);
      setEditingQuestionIndex(null);
    } else {
      // Add new question
      const newQuestion = {
        text: currentQuestion,
        format: selectedFormat,
        graphic: selectedGraphic,
      };
      setQuestions([...questions, newQuestion]);
    }
    resetQuestionForm();
  };

  const resetQuestionForm = () => {
    setCurrentQuestion("");
    setSelectedFormat(null);
    setSelectedGraphic(null);
  };

  const editQuestion = (index) => {
    const question = questions[index];
    if (question.graphic === "smileys" && ratingType === 10) {
      alert(
        "Smiley questions are not compatible with 10-point scale. Please remove or change this question first."
      );
      return;
    }
    setCurrentQuestion(question.text);
    setSelectedFormat(question.format);
    setSelectedGraphic(question.graphic);
    setEditingQuestionIndex(index);
    setStep(2);
  };

  const handleSaveSurvey = async () => {
    if (!template.trim()) {
      alert("Please enter a template name");
      return;
    }
    const formattedTemplateName = template
      .trim()
      .toLowerCase()
      .replace(/ /g, "_");
    const newTemplateKey = `${formattedTemplateName}_${ratingType}`;

    const newTemplate = {
      [newTemplateKey]: {
        desc: templateDescription,
        status: false,
        rating_options: ratingType,
        rating_selected: ratingType,
        selected_groups: [],
        components: questions.map((question, index) => ({
          [`q${index + 1}`]: question.text,
          answer: "",
          label:
            question.format === "text"
              ? "Text Input"
              : question.format === "numeric"
              ? "Numeric scale"
              : question.graphic === "smileys"
              ? `${ratingType} smileys`
              : question.graphic === "thumbs"
              ? "Thumbs up and down"
              : question.graphic === "stars"
              ? `${ratingType} stars`
              : question.graphic,
          type: question.format,
        })),
        score_question: selectedScoreQuestion,
        bench_mark: {
          min: benchmark.min,
          max: benchmark.max,
        },
      },
    };

    const updatedTemplates = {
      ...existingTemplates,
      ...newTemplate,
    };

    try {
      const config = getApiConfig();
      const response = await axios.post(
        ApiConfig.xSurveyUpdateSettings,
        { settings: updatedTemplates },
        config
      );
      console.log("Survey saved successfully:", response.data);
      setShowSuccessScreen(true);
    } catch (error) {
      console.error("Error saving survey:", error);
      alert("Failed to save survey. Please try again.");
    } finally {
      setShowScoreModal(false);
    }
  };

  const QuestionBadge = ({ number }) => (
    <div className="position-relative d-flex align-items-center gap-2">
      <div className="d-flex align-items-center">
        <span className="fw-medium me-1">Question</span>
        <div
          className="rounded-pill bg-white d-flex align-items-center justify-content-center shadow-sm"
          style={{
            width: "32px",
            height: "32px",
            border: `2px solid ${colors.primary}`,
          }}
        >
          <span
            className="fw-bold text-primary"
            style={{ fontSize: "14px", lineHeight: 1 }}
          >
            {number}
          </span>
        </div>
      </div>
    </div>
  );

  const handleRestartSurvey = () => {
    setShowSuccessScreen(false);
    setTemplate("");
    setTemplateDescription("");
    setQuestions([]);
    resetQuestionForm();
    setStep(1);
    setRatingType(null);
  };
  const calculateProgress = () => {
    // Step 1 progress (0-25%)
    if (step === 1) {
      let progress = 0;
      if (template) progress += 10;
      if (templateDescription) progress += 10;
      if (ratingType) progress += 5;
      return Math.min(25, progress);
    }

    // Step 2 progress (25-50%)
    if (step === 2) {
      let progress = 25;
      if (currentQuestion) progress += 15;
      if (selectedFormat) progress += 10;
      return Math.min(50, progress);
    }

    // Step 3 progress (50-75%)
    if (step === 3) {
      return selectedGraphic ? 75 : 50;
    }

    // Step 4 progress (75-100%)
    if (step === 4) {
      let progress = 75;
      if (questions.length > 0) progress += 15;
      if (selectedScoreQuestion) progress += 10;
      return Math.min(100, progress);
    }

    return 0;
  };

  const hasSmileyQuestions = () => {
    return questions.some((q) => q.graphic === "smileys");
  };

  if (isLoadingModules) return <Loader />;

  if (showSuccessScreen) {
    return (
      <Container className="text-center py-5">
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "60vh" }}
        >
          <AiOutlineCheckCircle size={80} className="text-success mb-4" />
          <h3 className="mb-3">Survey Created Successfully!</h3>
          <p className="text-muted mb-4">
            Your survey template is now ready to use.
          </p>
          <div className="d-flex gap-3">
            <Button
              variant="outline-primary"
              onClick={() => setShowSurvey(false)}
            >
              Back to Surveys
            </Button>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      {/* Progress Steps */}
      <div className="mb-5" style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* Step Indicators */}
        <div className="d-flex justify-content-between position-relative mb-3">
          {[1, 2, 3, 4].map((stepNum) => {
            const isActive = step >= stepNum;
            const isCurrent = step === stepNum;
            const isCompleted = step > stepNum;

            return (
              <div
                key={stepNum}
                className="d-flex flex-column align-items-center position-relative"
                style={{ zIndex: 2, width: "24%" }}
                onClick={() => isCompleted && setStep(stepNum)}
              >
                {/* Step Circle */}
                <div
                  className={`d-flex align-items-center justify-content-center ${
                    isActive ? "text-white" : "bg-light"
                  }`}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    background: isActive ? "#0a7be1" : "#f1f5f9",
                    border: `2px solid ${isActive ? "#0a7be1" : "#e2e8f0"}`,
                    transition: "all 0.3s ease",
                    cursor: isCompleted ? "pointer" : "default",
                    transform: isCurrent ? "scale(1.1)" : "scale(1)",
                    boxShadow: isCurrent
                      ? "0 0 0 4px rgba(10, 123, 225, 0.2)"
                      : "none",
                  }}
                >
                  {isCompleted ? (
                    <AiOutlineCheckCircle
                      size={18}
                      color="white"
                      className="progress-check-icon"
                    />
                  ) : (
                    <span className="fw-bold">{stepNum}</span>
                  )}
                </div>

                {/* Step Label */}
                <span
                  className="mt-2 text-center fw-medium"
                  style={{
                    color: isActive ? "#0a7be1" : colors.muted,
                    fontSize: "0.8rem",
                    transition: "color 0.3s ease",
                    width: "100%",
                  }}
                >
                  {stepNum === 1
                    ? "Details"
                    : stepNum === 2
                    ? "Questions"
                    : stepNum === 3
                    ? "Options"
                    : "Review"}
                </span>

                {/* Connecting line */}
                {stepNum < 4 && (
                  <div
                    className="position-absolute"
                    style={{
                      height: "2px",
                      width: "calc(100% - 36px)",
                      left: "calc(50% + 18px)",
                      top: "18px",
                      background: isActive
                        ? `linear-gradient(90deg, #0a7be1, ${
                            step >= stepNum + 1 ? "#0a7be1" : "#e2e8f0"
                          })`
                        : "#e2e8f0",
                      zIndex: -1,
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>

        {/* Progress Bar Track */}
        <div
          className="position-relative"
          style={{ height: "8px", width: "100%" }}
        >
          {/* Background Track */}
          <div
            className="position-absolute bg-light"
            style={{
              height: "100%",
              width: "100%",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          />

          {/* Progress Fill */}
          <div
            className="position-absolute"
            style={{
              height: "100%",
              width: `${calculateProgress()}%`,
              borderRadius: "4px",
              background: "#0a7be1",
              boxShadow: "0 2px 8px rgba(10, 123, 225, 0.3)",
              transition: "width 0.5s cubic-bezier(0.65, 0, 0.35, 1)",
            }}
          />
        </div>
      </div>

      {/* Step 1: Template Details */}
      {step === 1 && (
        <div className="mx-auto" style={{ maxWidth: "800px" }}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <h4 className="mb-4 text-center">Create New Survey Template</h4>

              <Form.Group className="mb-4">
                <Form.Label>Template Name</Form.Label>
                <Form.Control
                  type="text"
                  value={template}
                  onChange={(e) => setTemplate(e.target.value)}
                  placeholder="e.g., Customer Satisfaction Survey"
                  className="form-control-lg"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={templateDescription}
                  onChange={(e) => setTemplateDescription(e.target.value)}
                  placeholder="Describe the purpose of this survey..."
                  className="form-control-lg"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Rating Scale</Form.Label>
                <ToggleButtonGroup
                  type="radio"
                  name="ratingOptions"
                  value={ratingType}
                  onChange={setRatingType}
                  className="w-100"
                >
                  <ToggleButton
                    id="rating-5"
                    variant="outline-primary"
                    value={5}
                    className="py-2"
                  >
                    5-Point Scale
                  </ToggleButton>
                  <ToggleButton
                    id="rating-10"
                    variant="outline-primary"
                    value={10}
                    className="py-2"
                    disabled={hasSmileyQuestions()}
                  >
                    10-Point Scale
                  </ToggleButton>
                </ToggleButtonGroup>
                <Form.Text className="text-muted">
                  Choose between 5-star or 10-star rating system
                </Form.Text>
              </Form.Group>

              <div className="d-flex justify-content-end mt-4">
                <Button
                  variant="primary"
                  onClick={handleNext}
                  disabled={!template || !ratingType}
                  className="px-4 py-2"
                >
                  Next
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Step 2: Question Format */}
      {step === 2 && (
        <div className="mx-auto" style={{ maxWidth: "800px" }}>
          <Card className="border-0 shadow-sm" style={{ overflow: "hidden" }}>
            <Card.Body className="p-0">
              {/* Header Section */}
              <div className="bg-primary bg-opacity-10 p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Conditionally render back button */}
                  {questions.length === 0 && (
                    <Button
                      variant="link"
                      onClick={handlePrevious}
                      className="text-decoration-none p-0 text-primary"
                    >
                      <AiOutlineArrowLeft size={20} className="me-2" />
                      Back
                    </Button>
                  )}
                  {questions.length > 0 && <div></div>}
                  <QuestionBadge
                    number={
                      editingQuestionIndex !== null
                        ? editingQuestionIndex + 1
                        : questions.length + 1
                    }
                  />
                </div>

                <Form.Group className="mb-0">
                  <Form.Label className="fw-medium text-muted mb-2">
                    Question Text
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={currentQuestion}
                    onChange={(e) => setCurrentQuestion(e.target.value)}
                    placeholder="Enter your question here..."
                    className="form-control-lg border-1 py-2 bg-white"
                    style={{
                      borderRadius: "8px",
                      borderColor: "#e2e8f0",
                      transition: "border-color 0.3s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = colors.primary;
                      e.target.style.boxShadow = `0 0 0 0.2rem ${colors.primary}20`;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e2e8f0";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </Form.Group>
              </div>

              {/* Response Format Options */}
              <div className="p-4">
                <h5 className="mb-3 fw-medium">Response Format</h5>
                <Row className="g-3">
                  {responseFormats.map((format) => (
                    <Col md={4} key={format.value}>
                      <div
                        className={`h-100 cursor-pointer transition-all position-relative ${
                          selectedFormat === format.value
                            ? "border-primary"
                            : "border-light"
                        }`}
                        onClick={() => setSelectedFormat(format.value)}
                        style={{
                          borderWidth:
                            selectedFormat === format.value ? "2px" : "1px",
                          borderRadius: "12px",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          transform:
                            selectedFormat === format.value
                              ? "translateY(-2px)"
                              : "none",
                          boxShadow:
                            selectedFormat === format.value
                              ? "0 4px 20px rgba(99, 102, 241, 0.15)"
                              : "0 2px 8px rgba(0, 0, 0, 0.05)",
                          borderColor:
                            selectedFormat === format.value
                              ? colors.primary
                              : "#e2e8f0",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedFormat !== format.value) {
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(0, 0, 0, 0.1)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedFormat !== format.value) {
                            e.currentTarget.style.transform = "none";
                            e.currentTarget.style.boxShadow =
                              "0 2px 8px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        {/* Selection Indicator */}
                        {selectedFormat === format.value && (
                          <div
                            className="position-absolute top-0 end-0 bg-primary text-white rounded-bl-lg rounded-tr-lg px-2 py-1"
                            style={{
                              fontSize: "12px",
                              zIndex: 1,
                            }}
                          >
                            <AiOutlineCheckCircle size={16} />
                          </div>
                        )}

                        <div className="p-4 h-100 d-flex flex-column align-items-center">
                          <div
                            className="mb-3 text-primary"
                            style={{
                              transform:
                                selectedFormat === format.value
                                  ? "scale(1.1)"
                                  : "scale(1)",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            {format.icon}
                          </div>
                          <h6 className="text-center mb-2">{format.title}</h6>
                          <p className="text-muted small text-center mb-0">
                            {format.description}
                          </p>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>

              {/* Footer with Action Buttons */}
              <div className="bg-light p-4 border-top">
                <div className="d-flex justify-content-between">
                  <Button
                    variant="outline-primary"
                    onClick={() => {
                      if (editingQuestionIndex !== null) {
                        setStep(4);
                        setEditingQuestionIndex(null);
                      } else {
                        handlePrevious();
                      }
                      resetQuestionForm();
                    }}
                    className="px-4 rounded-pill"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleNext}
                    disabled={!currentQuestion || !selectedFormat}
                    className="px-4 rounded-pill shadow-sm"
                    style={{
                      transform:
                        !currentQuestion || !selectedFormat
                          ? "none"
                          : "scale(1.02)",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (currentQuestion && selectedFormat) {
                        e.currentTarget.style.transform = "scale(1.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (currentQuestion && selectedFormat) {
                        e.currentTarget.style.transform = "scale(1.02)";
                      }
                    }}
                  >
                    {selectedFormat === "graphic"
                      ? "Choose Options"
                      : editingQuestionIndex !== null
                      ? "Update Question"
                      : "Add Question"}
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Step 3: Graphic Options */}
      {step === 3 && (
        <div className="mx-auto" style={{ maxWidth: "800px" }}>
          <Card className="border-0 shadow-sm" style={{ overflow: "hidden" }}>
            <Card.Body className="p-0">
              {/* Header Section */}
              <div className="bg-primary bg-opacity-10 p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Button
                    variant="link"
                    onClick={handlePrevious}
                    className="text-decoration-none p-0 text-primary"
                  >
                    <AiOutlineArrowLeft size={16} className="me-2" />
                    Back
                  </Button>
                  <QuestionBadge
                    number={
                      editingQuestionIndex !== null
                        ? editingQuestionIndex + 1
                        : questions.length + 1
                    }
                  />
                </div>

                {/* Current Question Preview */}
                <div className="bg-white rounded p-3 shadow-sm mb-0">
                  <p className="mb-0 text-center fw-semibold">
                    {currentQuestion}
                  </p>
                </div>
              </div>

              {/* Graphic Options Grid */}
              <div className="p-4">
                <h5 className="mb-3 fw-medium text-center">
                  Select Response Style
                </h5>
                <p className="text-muted text-center mb-4">
                  Choose how respondents will answer this question
                </p>

                <Row className="g-4">
                  {graphicOptions.map((option) => (
                    <Col md={6} key={option.value}>
                      <div
                        className={`h-100 cursor-pointer transition-all position-relative ${
                          selectedGraphic === option.value
                            ? "border-primary"
                            : "border-light"
                        }`}
                        onClick={() => setSelectedGraphic(option.value)}
                        style={{
                          borderWidth:
                            selectedGraphic === option.value ? "2px" : "1px",
                          borderRadius: "12px",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          transform:
                            selectedGraphic === option.value
                              ? "translateY(-2px)"
                              : "none",
                          boxShadow:
                            selectedGraphic === option.value
                              ? "0 4px 20px rgba(99, 102, 241, 0.15)"
                              : "0 2px 8px rgba(0, 0, 0, 0.05)",
                          borderColor:
                            selectedGraphic === option.value
                              ? colors.primary
                              : "#e2e8f0",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedGraphic !== option.value) {
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(0, 0, 0, 0.1)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedGraphic !== option.value) {
                            e.currentTarget.style.transform = "none";
                            e.currentTarget.style.boxShadow =
                              "0 2px 8px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        {/* Selection Indicator */}
                        {selectedGraphic === option.value && (
                          <div
                            className="position-absolute top-0 end-0 bg-primary text-white rounded-bl-lg rounded-tr-lg px-2 py-1"
                            style={{
                              fontSize: "12px",
                              zIndex: 1,
                            }}
                          >
                            <AiOutlineCheckCircle size={16} />
                          </div>
                        )}

                        <div className="p-4 h-100 d-flex flex-column">
                          <div
                            className="mb-3 d-flex justify-content-center align-items-center"
                            style={{
                              minHeight: "60px",
                              transform:
                                selectedGraphic === option.value
                                  ? "scale(1.05)"
                                  : "scale(1)",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            {option.icon}
                          </div>

                          <h6 className="text-center mb-3">{option.label}</h6>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>

              {/* Footer with Action Buttons */}
              <div className="bg-light p-4 border-top">
                <div className="d-flex justify-content-between">
                  <Button
                    variant="outline-primary"
                    onClick={handlePrevious}
                    className="px-4 rounded-pill"
                  >
                    Back
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleNext}
                    disabled={!selectedGraphic}
                    className="px-4 rounded-pill shadow-sm"
                    style={{
                      transform: !selectedGraphic ? "none" : "scale(1.02)",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (selectedGraphic) {
                        e.currentTarget.style.transform = "scale(1.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedGraphic) {
                        e.currentTarget.style.transform = "scale(1.02)";
                      }
                    }}
                  >
                    {editingQuestionIndex !== null
                      ? "Update Question"
                      : "Add Question"}
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Step 4: Survey Review */}
      {step === 4 && (
        <div className="mx-auto" style={{ maxWidth: "800px" }}>
          <Card className="border-0 shadow-sm mb-4">
            <Card.Body className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Survey Review</h4>
                <div>
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowPreview(true)}
                    className="me-2"
                  >
                    <AiOutlineEye className="me-1" /> Preview
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => setShowScoreModal(true)}
                    disabled={questions.length === 0}
                  >
                    <AiOutlineUpload className="me-1 progress-check-icon" />{" "}
                    Publish Survey
                  </Button>
                </div>
              </div>

              {/* Template Details Card - Now Editable */}
              <Card className="mb-4 border-0 bg-light position-relative">
                {editingTemplate ? (
                  <Card.Body className="p-4">
                    <Form.Group className="mb-3">
                      <Form.Label>Template Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={template}
                        onChange={(e) => setTemplate(e.target.value)}
                        className="form-control-lg"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={templateDescription}
                        onChange={(e) => setTemplateDescription(e.target.value)}
                        className="form-control-lg"
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Rating Scale</Form.Label>
                      <ToggleButtonGroup
                        type="radio"
                        name="ratingOptions"
                        value={ratingType}
                        onChange={(newRatingType) => {
                          if (newRatingType === 10 && hasSmileyQuestions()) {
                            if (
                              window.confirm(
                                "Changing to 10-point scale will remove all smiley rating questions. Continue?"
                              )
                            ) {
                              // Remove all smiley questions
                              setQuestions(
                                questions.filter((q) => q.graphic !== "smileys")
                              );
                              setRatingType(newRatingType);
                            }
                          } else {
                            setRatingType(newRatingType);
                          }
                        }}
                        className="w-100"
                      >
                        <ToggleButton
                          id="rating-5"
                          variant="outline-primary"
                          value={5}
                          className="py-2"
                        >
                          5-Point Scale
                        </ToggleButton>
                        <ToggleButton
                          id="rating-10"
                          variant="outline-primary"
                          value={10}
                          className="py-2"
                        >
                          10-Point Scale
                        </ToggleButton>
                      </ToggleButtonGroup>

                      {questions.length > 0 && (
                        <Form.Text className="text-muted">
                          {ratingType === 5 && hasSmileyQuestions() && (
                            <span className="text-warning">
                              You cannot switch to a 10-point scale because
                              smiley questions are not compatible with it
                            </span>
                          )}
                          {ratingType === 10 &&
                            "Smiley questions are not available for 10-point scale"}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        variant="primary"
                        onClick={() => setEditingTemplate(false)}
                      >
                        Save Changes
                      </Button>
                    </div>
                  </Card.Body>
                ) : (
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h5 className="mb-3">{template}</h5>
                        <p className="text-muted">{templateDescription}</p>
                        <div className="d-flex gap-2">
                          <Badge bg="light" text="dark">
                            {ratingType === 5
                              ? "5-Point Scale"
                              : "10-Point Scale"}
                          </Badge>
                          <Badge bg="light" text="dark">
                            Benchmarks: {benchmark.min} (Min) / {benchmark.max}{" "}
                            (Max)
                          </Badge>
                        </div>
                      </div>
                      <Button
                        variant="link"
                        className="p-0 text-primary"
                        onClick={() => setEditingTemplate(true)}
                      >
                        <AiOutlineEdit size={18} />
                      </Button>
                    </div>
                  </Card.Body>
                )}
              </Card>

              {/* Questions List */}
              {questions.map((question, index) => {
                const questionKey = `q${index + 1}`;
                const currentAnswer = answers[questionKey] || "";

                return (
                  <Card
                    key={index}
                    className="mb-3 border-0 shadow-sm position-relative"
                  >
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 className="mb-1">Question {index + 1}</h6>
                          <p className="mb-2">{question.text}</p>
                          <Badge bg="light" text="dark" className="me-2">
                            {question.format === "text"
                              ? "Text Response"
                              : question.format === "numeric"
                              ? "Numeric Scale"
                              : question.graphic === "stars"
                              ? "Star Rating"
                              : question.graphic === "thumbs"
                              ? "Thumbs Rating"
                              : "Smiley Scale"}
                          </Badge>
                          {question.format === "graphic" && (
                            <div className="mt-2">
                              {question.graphic === "stars" && (
                                <div className="d-flex gap-2">
                                  {[...Array(ratingType === 5 ? 5 : 10)].map(
                                    (_, i) => (
                                      <img
                                        key={i}
                                        src={star}
                                        width={20}
                                        height={20}
                                        alt="star"
                                      />
                                    )
                                  )}
                                </div>
                              )}
                              {question.graphic === "thumbs" && (
                                <div className="d-flex gap-3">
                                  <img
                                    src={thumbUp}
                                    width={24}
                                    height={24}
                                    alt="thumbs up"
                                  />
                                  <img
                                    src={thumbDown}
                                    width={24}
                                    height={24}
                                    alt="thumbs down"
                                  />
                                </div>
                              )}
                              {question.graphic === "smileys" && (
                                <div className="d-flex gap-2">
                                  <img
                                    src={angry}
                                    width={20}
                                    height={20}
                                    alt="angry"
                                  />
                                  <img
                                    src={frown}
                                    width={20}
                                    height={20}
                                    alt="frown"
                                  />
                                  <img
                                    src={meh}
                                    width={20}
                                    height={20}
                                    alt="neutral"
                                  />
                                  <img
                                    src={smile}
                                    width={20}
                                    height={20}
                                    alt="smile"
                                  />
                                  <img
                                    src={happyHeart}
                                    width={20}
                                    height={20}
                                    alt="happy"
                                  />
                                </div>
                              )}
                            </div>
                          )}
                          {question.format === "numeric" && (
                            <div className="d-flex justify-content-center flex-wrap gap-2 mt-3">
                              {Array.from(
                                { length: ratingType },
                                (_, i) => i + 1
                              ).map((number) => (
                                <div
                                  key={number}
                                  className={`p-2 rounded-2 cursor-pointer transition-all ${
                                    answers[`q${index + 1}`] === number
                                      ? "bg-primary bg-opacity-10"
                                      : "hover-bg-light"
                                  }`}
                                >
                                  <span
                                    className="fw-bold"
                                    style={{
                                      color:
                                        answers[`q${index + 1}`] === number
                                          ? colors.primary
                                          : colors.muted,
                                      fontSize: "16px",
                                    }}
                                  >
                                    {number}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                          {question.format === "text" && (
                            <Form.Control
                              as="textarea"
                              rows={2}
                              placeholder="Response will appear here..."
                              className="mt-2"
                              disabled
                            />
                          )}
                        </div>
                        <div className="position-absolute top-0 end-0 mt-2 me-2">
                          <Button
                            variant="link"
                            size="sm"
                            className="text-primary p-0 mr-2 me-2"
                            onClick={() => editQuestion(index)}
                          >
                            {/* <AiOutlineEdit size={18} /> */}
                            edit
                          </Button>
                          <Button
                            variant="link"
                            size="sm"
                            className="text-danger p-0"
                            onClick={() => {
                              const updatedQuestions = [...questions];
                              updatedQuestions.splice(index, 1);
                              setQuestions(updatedQuestions);
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                );
              })}

              <Button
                variant="outline-primary"
                className="w-100 mt-3"
                onClick={() => {
                  resetQuestionForm();
                  setStep(2);
                }}
              >
                <AiOutlinePlus className="me-1" /> Add Another Question
              </Button>
            </Card.Body>
          </Card>
        </div>
      )}

      {/* Score Question Modal */}
      <Modal
        show={showScoreModal}
        onHide={() => {
          setShowScoreModal(false);
          setPublishStep(1);
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Publish Survey</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Progress Steps */}
          <div className="d-flex justify-content-center mb-6">
            <div className="position-relative" style={{ width: "80%" }}>
              <div className="progress" style={{ height: "6px" }}>
                <div
                  className="progress-bar bg-primary"
                  role="progressbar"
                  style={{
                    width: `${publishStep === 1 ? 50 : 100}%`,
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
              <div
                className="d-flex justify-content-between position-absolute w-100"
                style={{ top: "-10px" }}
              >
                {[1, 2].map((stepNum) => (
                  <div
                    key={stepNum}
                    className={`d-flex flex-column align-items-center ${
                      publishStep >= stepNum ? "text-primary" : "text-muted"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      stepNum < publishStep && setPublishStep(stepNum)
                    }
                  >
                    <div
                      className={`rounded-circle d-flex align-items-center justify-content-center ${
                        publishStep >= stepNum
                          ? "bg-primary text-white"
                          : "bg-light"
                      }`}
                      style={{
                        width: "30px",
                        height: "30px",
                        border: `2px solid ${
                          publishStep >= stepNum ? colors.primary : colors.muted
                        }`,
                      }}
                    >
                      {stepNum}
                    </div>
                    <small className="mt-1">
                      {stepNum === 1 ? "Benchmarks" : "Score Question"}
                    </small>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Step 1: Benchmark Settings */}
          {publishStep === 1 && (
            <div className="benchmark-container">
              <div className="text-center mb-4">
                <h5 className="fw-bold mb-2">Set Satisfaction Thresholds</h5>
                <p className="text-muted">
                  Select what scores count as Bad, Average, and Good
                </p>
              </div>

              {/* Interactive Rating Selector */}
              <div className="rating-selector mb-4">
                <div className="d-flex justify-content-between mb-3">
                  {[...Array(ratingType)].map((_, i) => {
                    const score = i + 1;
                    const isMin = score === benchmark.min;
                    const isMax = score === benchmark.max;
                    let className = "rating-point";

                    if (score <= benchmark.min) className += " bad";
                    else if (score < benchmark.max) className += " average";
                    else className += " good";

                    if (isMin || isMax) className += " active";

                    return (
                      <div
                        key={score}
                        className={className}
                        onClick={() => {
                          if (score <= benchmark.min) {
                            const newMax = Math.min(
                              ratingType,
                              Math.max(benchmark.max, score + 2)
                            );
                            setBenchmark({ min: score, max: newMax });
                          } else if (score >= benchmark.max) {
                            const newMin = Math.max(
                              1,
                              Math.min(benchmark.min, score - 2)
                            );
                            setBenchmark({ min: newMin, max: score });
                          } else {
                            const distanceToMin = Math.abs(
                              score - benchmark.min
                            );
                            const distanceToMax = Math.abs(
                              score - benchmark.max
                            );
                            if (distanceToMin < distanceToMax) {
                              setBenchmark({
                                min: score,
                                max: Math.max(benchmark.max, score + 2),
                              });
                            } else {
                              setBenchmark({
                                min: Math.min(benchmark.min, score - 2),
                                max: score,
                              });
                            }
                          }
                        }}
                      >
                        <div className="point-value">{score}</div>
                        {isMin && (
                          <div className="threshold-label min">Min</div>
                        )}
                        {isMax && (
                          <div className="threshold-label max">Max</div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Visual Scale Bar */}
                <div className="scale-bar">
                  <div
                    className="scale-segment bad"
                    style={{ width: `${(benchmark.min / ratingType) * 100}%` }}
                  ></div>
                  <div
                    className="scale-segment average"
                    style={{
                      width: `${
                        ((benchmark.max - benchmark.min - 1) / ratingType) * 100
                      }%`,
                    }}
                  ></div>
                  <div
                    className="scale-segment good"
                    style={{
                      width: `${
                        ((ratingType - benchmark.max + 1) / ratingType) * 100
                      }%`,
                    }}
                  ></div>
                </div>

                {/* Legend */}
                <div className="d-flex justify-content-between mt-3">
                  <div className="d-flex align-items-center">
                    <div className="legend-color bad"></div>
                    <small className="ms-2">Bad (1-{benchmark.min})</small>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="legend-color average"></div>
                    <small className="ms-2">
                      Average ({benchmark.min + 1}-{benchmark.max - 1})
                    </small>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="legend-color good"></div>
                    <small className="ms-2">
                      Good ({benchmark.max}-{ratingType})
                    </small>
                  </div>
                </div>
              </div>

              {/* Preset Buttons */}
              <div className="presets mb-4">
                <small className="d-block mb-2 text-muted">
                  Quick presets:
                </small>
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() =>
                      setBenchmark({
                        min: ratingType === 5 ? 2 : 4,
                        max: ratingType === 5 ? 4 : 7,
                      })
                    }
                  >
                    Default
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() =>
                      setBenchmark({
                        min: Math.floor(ratingType * 0.3),
                        max: Math.ceil(ratingType * 0.7),
                      })
                    }
                  >
                    Balanced
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() =>
                      setBenchmark({
                        min: Math.floor(ratingType * 0.2),
                        max: Math.ceil(ratingType * 0.6),
                      })
                    }
                  >
                    Lenient
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() =>
                      setBenchmark({
                        min: Math.floor(ratingType * 0.4),
                        max: Math.ceil(ratingType * 0.8),
                      })
                    }
                  >
                    Strict
                  </Button>
                </div>
              </div>

              {/* Summary Card */}
              <Card className="border-0 bg-light">
                <Card.Body className="p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-1">Current Thresholds</h6>
                      <p className="mb-0 small text-muted">
                        Scores ≤ {benchmark.min} are Bad, ≥ {benchmark.max} are
                        Good
                      </p>
                    </div>
                    <div className="text-end">
                      <Badge bg="danger" className="me-1">
                        1-{benchmark.min}
                      </Badge>
                      <Badge bg="warning" className="me-1">
                        {benchmark.min + 1}-{benchmark.max - 1}
                      </Badge>
                      <Badge bg="success">
                        {benchmark.max}-{ratingType}
                      </Badge>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          )}

          {/* Step 2: Score Question Selection */}
          {publishStep === 2 && (
            <div>
              <h5 className="mb-3">Select Score Question</h5>
              <p className="text-muted mb-4">
                Choose which question will be used to calculate the overall
                satisfaction score. Only numeric and graphic (stars/smileys)
                questions are shown.
              </p>

              {questions
                .filter((q) => q.format !== "text" && q.graphic !== "thumbs")
                .map((question, index) => (
                  <Card
                    key={index}
                    className={`mb-3 cursor-pointer ${
                      selectedScoreQuestion === `q${index + 1}`
                        ? "border-primary"
                        : ""
                    }`}
                    onClick={() => setSelectedScoreQuestion(`q${index + 1}`)}
                  >
                    <Card.Body className="p-3">
                      <div className="d-flex align-items-center">
                        <Form.Check
                          type="radio"
                          name="scoreQuestion"
                          id={`score-q${index}`}
                          checked={selectedScoreQuestion === `q${index + 1}`}
                          onChange={() =>
                            setSelectedScoreQuestion(`q${index + 1}`)
                          }
                          className="me-3"
                        />
                        <div>
                          <p className="mb-0 fw-semibold">{question.text}</p>
                          <small className="text-muted">
                            {question.format === "numeric"
                              ? "Numeric Scale"
                              : question.graphic === "stars"
                              ? "Star Rating"
                              : "Smiley Scale"}
                          </small>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                ))}

              {questions.filter(
                (q) => q.format !== "text" && q.graphic !== "thumbs"
              ).length === 0 && (
                <div className="alert alert-warning">
                  No eligible questions found for scoring. Please add numeric or
                  rating (stars/smileys) questions.
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {publishStep === 1 ? (
            <>
              <Button
                variant="secondary"
                onClick={() => {
                  setBenchmark({
                    min: ratingType === 5 ? 2 : 4,
                    max: ratingType === 5 ? 4 : 7,
                  });
                }}
              >
                Reset Defaults
              </Button>
              <Button
                variant="primary"
                onClick={() => setPublishStep(2)}
                disabled={benchmark.min >= benchmark.max}
              >
                Continue to Score Question
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="outline-secondary"
                onClick={() => setPublishStep(1)}
              >
                Back
              </Button>
              <Button
                variant="primary"
                onClick={handleSaveSurvey}
                disabled={!selectedScoreQuestion}
              >
                Publish Survey
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* Preview Modal */}
      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold">Survey Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {/* Survey Header */}
          <div className="bg-primary bg-gradient py-3 text-white rounded-top mb-4">
            <div className="text-center py-1">
              <h1 className="fw-bold mb-1" style={{ fontSize: "18px" }}>
                We Value Your Feedback
              </h1>
              <p className="mb-0" style={{ fontSize: "12px" }}>
                Help us improve by sharing your experience
              </p>
            </div>
          </div>

          {/* Survey Content */}
          <div className="bg-white rounded-bottom shadow-sm p-4">
            <div className="text-center mb-4">
              <h2 className="fw-bold mb-2" style={{ fontSize: "20px" }}>
                {template}
              </h2>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Please take a few moments to share your thoughts
              </p>
            </div>

            {questions.map((question, index) => {
              const questionKey = `q${index + 1}`;
              const currentAnswer = answers[questionKey] || "";

              return (
                <div key={index} className="mb-4">
                  {question.format === "text" && (
                    <div className="border-0 rounded-3 p-3 mb-3 bg-white shadow-sm">
                      <p
                        className="fw-semibold mb-2 text-center text-dark"
                        style={{ fontSize: "15px" }}
                      >
                        {question.text}
                      </p>
                      <Form.Group className="mx-auto">
                        <Form.Control
                          as="textarea"
                          rows={2}
                          placeholder="Type your feedback here..."
                          value={currentAnswer}
                          onChange={(e) =>
                            handleAnswerChange(questionKey, e.target.value)
                          }
                          className="border-1"
                          style={{
                            borderRadius: "10px",
                            fontSize: "14px",
                            borderColor: "#e0e0e0",
                            minHeight: "90px",
                          }}
                        />
                      </Form.Group>
                    </div>
                  )}

                  {question.format === "graphic" &&
                    question.graphic === "thumbs" && (
                      <div className="border-0 rounded-3 p-3 mb-3 bg-white shadow-sm text-center">
                        <p
                          className="fw-semibold mb-2 text-dark"
                          style={{ fontSize: "15px" }}
                        >
                          {question.text}
                        </p>
                        <div className="d-flex justify-content-center gap-3">
                          <div
                            className={`p-2 rounded-2 cursor-pointer transition-all ${
                              currentAnswer === 1
                                ? "bg-primary bg-opacity-10"
                                : "hover-bg-light"
                            }`}
                            onClick={() =>
                              handleAnswerChange(
                                questionKey,
                                currentAnswer === 1 ? 0 : 1
                              )
                            }
                          >
                            <img
                              src={currentAnswer === 1 ? thumbUpBlack : thumbUp}
                              alt="thumbs up"
                              style={{ width: "26px", height: "26px" }}
                            />
                          </div>
                          <div
                            className={`p-2 rounded-2 cursor-pointer transition-all ${
                              currentAnswer === 2
                                ? "bg-danger bg-opacity-10"
                                : "hover-bg-light"
                            }`}
                            onClick={() =>
                              handleAnswerChange(
                                questionKey,
                                currentAnswer === 2 ? 0 : 2
                              )
                            }
                          >
                            <img
                              src={
                                currentAnswer === 2 ? thumbDownBlack : thumbDown
                              }
                              alt="thumbs down"
                              style={{ width: "26px", height: "26px" }}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                  {question.format === "graphic" &&
                    question.graphic === "smileys" && (
                      <div className="border-0 rounded-3 p-3 mb-3 bg-white shadow-sm text-center">
                        <p
                          className="fw-semibold mb-2 text-dark"
                          style={{ fontSize: "15px" }}
                        >
                          {question.text}
                        </p>
                        <div className="d-flex justify-content-center flex-wrap gap-2">
                          {smileys.map((icon, i) => {
                            const number = i + 1;
                            const isSelected =
                              currentAnswer && number <= currentAnswer;
                            let colorClass = "";
                            if (number <= benchmark.min) {
                              colorClass = "bad-bg";
                            } else if (number < benchmark.max) {
                              colorClass = "average-bg";
                            } else {
                              colorClass = "good-bg";
                            }

                            return (
                              <div
                                key={i}
                                className={`p-2 rounded-2 cursor-pointer transition-all ${
                                  isSelected ? colorClass : ""
                                }`}
                                onClick={() =>
                                  handleAnswerChange(questionKey, number)
                                }
                                style={{
                                  border: `1px solid ${
                                    isSelected
                                      ? "transparent"
                                      : number <= benchmark.min
                                      ? "#fecaca"
                                      : number < benchmark.max
                                      ? "#fed7aa"
                                      : "#bbf7d0"
                                  }`,
                                  backgroundColor: isSelected
                                    ? number <= benchmark.min
                                      ? "#fee2e2"
                                      : number < benchmark.max
                                      ? "#ffedd5"
                                      : "#dcfce7"
                                    : "transparent",
                                }}
                              >
                                <img
                                  src={isSelected ? smileysBlack[i] : icon}
                                  style={{ width: "26px", height: "26px" }}
                                  alt={`smiley-${i}`}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                  {question.format === "graphic" &&
                    question.graphic === "stars" && (
                      <div className="border-0 rounded-3 p-3 mb-3 bg-white shadow-sm text-center">
                        <p
                          className="fw-semibold mb-2 text-dark"
                          style={{ fontSize: "15px" }}
                        >
                          {question.text}
                        </p>
                        <div className="d-flex justify-content-center flex-wrap gap-2">
                          {[...Array(ratingType === 5 ? 5 : 10)].map((_, i) => (
                            <div
                              key={i}
                              className={`p-2 rounded-2 cursor-pointer transition-all ${
                                i + 1 <= currentAnswer
                                  ? "bg-primary bg-opacity-10"
                                  : "hover-bg-light"
                              }`}
                              onClick={() =>
                                handleAnswerChange(questionKey, i + 1)
                              }
                            >
                              <img
                                src={i + 1 <= currentAnswer ? starBlack : star}
                                style={{ width: "26px", height: "26px" }}
                                alt="star"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  {question.format === "numeric" && (
                    <div className="border-0 rounded-3 p-3 mb-3 bg-white shadow-sm text-center">
                      <p
                        className="fw-semibold mb-2 text-dark"
                        style={{ fontSize: "15px" }}
                      >
                        {question.text}
                      </p>
                      <div className="d-flex justify-content-center flex-wrap gap-2">
                        {Array.from(
                          { length: ratingType },
                          (_, i) => i + 1
                        ).map((number) => {
                          const isSelected =
                            currentAnswer && number <= currentAnswer;
                          let colorClass = "";
                          if (number <= benchmark.min) {
                            colorClass = "bad-bg";
                          } else if (number < benchmark.max) {
                            colorClass = "average-bg";
                          } else {
                            colorClass = "good-bg";
                          }

                          return (
                            <div
                              key={number}
                              className={`p-2 rounded-2 cursor-pointer transition-all ${
                                isSelected ? colorClass : ""
                              }`}
                              onClick={() =>
                                handleAnswerChange(questionKey, number)
                              }
                              style={{
                                border: `1px solid ${
                                  isSelected
                                    ? "transparent"
                                    : number <= benchmark.min
                                    ? "#fecaca"
                                    : number < benchmark.max
                                    ? "#fed7aa"
                                    : "#bbf7d0"
                                }`,
                                backgroundColor: isSelected
                                  ? number <= benchmark.min
                                    ? "#fee2e2"
                                    : number < benchmark.max
                                    ? "#ffedd5"
                                    : "#dcfce7"
                                  : "transparent",
                              }}
                            >
                              <span
                                className="fw-bold d-block"
                                style={{
                                  color:
                                    number <= benchmark.min
                                      ? "#ef4444"
                                      : number < benchmark.max
                                      ? "#f97316"
                                      : "#22c55e",
                                  fontSize: "18px",
                                  width: "26px",
                                  height: "26px",
                                  lineHeight: "26px",
                                }}
                              >
                                {number}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            {/* Submit Button (non-functional in preview) */}
            <div className="d-flex justify-content-center mt-4">
              <Button
                variant="primary"
                className="px-4 py-2 rounded-pill fw-semibold shadow"
                style={{ minWidth: "140px" }}
                disabled
              >
                Submit Feedback
              </Button>
            </div>
          </div>

          {/* Footer Note */}
          <div className="text-center mt-4">
            <p className="text-muted small">
              This is a preview only. Responses will not be saved.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            onClick={() => setShowPreview(false)}
            className="rounded-pill px-3"
          >
            Close Preview
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default SurveyBuilder;
